import React from "react";
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

const Field = function (
    {
        show_quick_search = true,
        quick_search_placeholder = ''
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();
    const q = searchParams.has('q') ? searchParams.get('q') : '';

    if (show_quick_search) {
        return (
            <div>
                <label className="sr-only" htmlFor="quick_search">Quick Search</label>
                <input
                    placeholder={quick_search_placeholder}
                    value={q}
                    onChange={event => {
                        let params = searchParams;
                        params.set('q', event.target.value);
                        setSearchParams(params);
                    }}
                    type="text"
                    className="form-control quick-search little"
                    id="quick_search"/>
            </div>
        );
    }
}

Field.propTypes = {
    entity: PropTypes.string,
    show_quick_search: PropTypes.bool,
    quick_search_placeholder: PropTypes.string
};

export default Field;
